import { NameAttributes } from "@/entities/api/products/product"

const nameAttributeConvert = (name: NameAttributes) => {
    switch (name) {
        case NameAttributes.COLOR:
            return 'Colores'
        case NameAttributes.FLAVOR:
            return 'Sabores'
        case NameAttributes.MODALITY:
            return 'Modalidad'
        case NameAttributes.OBJECTIVE:
            return 'Objectivos'
        case NameAttributes.SIZE:
            return 'Tallas'
        default:
            return 'Sin nombre'
    }
}

export default nameAttributeConvert
